import { useEffect } from 'react';
import { useConsent } from '../ConsentContext';

export const Facebook = () => {
  const { consent } = useConsent();

  useEffect(() => {
    if (consent === 'decline') {
      const script = document.getElementById('facebook-pixel');
      document.cookie = `_fbp=; Max-Age=0; path=/; domain=${window.location.hostname};`;
      if (script) {
        script.remove();
      }
    } else {
      if (consent === 'accept' || document.cookie.indexOf(`cookies_accepted=`) === -1) {
        const script = document.createElement('script');
        script.id = 'facebook-pixel';
        script.innerHTML = `!function (f, b, e, v, n, t, s) {if (f.fbq) return; n = f.fbq = function () {n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)};if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';n.queue = []; t = b.createElement(e); t.async = !0;t.src = v; s = b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t, s)}(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');fbq('init', '${process.env.REACT_APP_FACEBOOK}');fbq('track', 'PageView');`;
        document.head.appendChild(script);
      }
    }
  }, [consent]);

  return (
    <>
      {consent && (
        <noscript>
          <img
            height="1"
            width="1"
            src={`https://www.facebook.com/tr?id=${process.env.REACT_APP_FACEBOOK}&ev=PageView&noscript=1`}
            alt="Facebook Pixel"
          />
        </noscript>
      )}
    </>
  );
};
